import { Component } from '@angular/core';

@Component({
  selector: 'greco-legal-page',
  templateUrl: './legal.page.html',
  styleUrls: ['./legal.page.scss'],
})
export class LegalPage {}
